import { memo, useMemo } from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { UseFormReturn } from 'react-hook-form';

import { FormItem } from 'components/shared';
import { TextFieldElement } from 'components/muiInputWrappers';
import { validationRules } from 'helpers/utils';
import useDebounce from 'hooks/utils/useDebounce';

interface IProps {
  id: string;
  form: UseFormReturn;
  isEditable?: boolean;
  isRequired?: boolean;
  onChange: (id: string, key: string, value: string) => void;
}

function Question({
  id,
  form,
  isEditable = true,
  isRequired = false,
  onChange
}: IProps) {
  const { t } = useTranslation('global');
  const { validateSpaces } = validationRules();

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const label: string = form.watch(`${id}-label`);

  const labelDebounce = useDebounce(label, 500);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useMemo(() => onChange(id, 'label', labelDebounce), [id, labelDebounce]);

  return (
    <div style={{ width: '100%' }}>
      {isEditable ? (
        <FormItem style={{ width: '100%' }}>
          <TextFieldElement
            control={form.control}
            inputProps={{
              type: 'text'
            }}
            name={`${id}-label`}
            placeholder={t('survey.template.withoutQuestion')}
            size="small"
            validation={{
              maxLength: {
                value: 240,
                message: t('ticket.messages.valueLongerThan240')
              },
              validate: validateSpaces
            }}
            variant="outlined"
            fullWidth
            required
          />
        </FormItem>
      ) : (
        <Typography fontWeight="500" variant="body1">
          {isRequired && (
            <Typography color="red" variant="caption">
              *
            </Typography>
          )}
          &nbsp;
          {label || t('survey.template.withoutQuestion')}
        </Typography>
      )}
    </div>
  );
}

export default memo(Question);
